import {EditableFieldModel} from "../edit-component.model";
import {FieldType} from "../model.map";

export class AiModel {
        content = new EditableFieldModel('content', FieldType.hidden, '');

        aiPrompt = new EditableFieldModel('Ai Prompt', FieldType.hidden, '');

        fieldsMap = [this.aiPrompt, this.content];

        constructor(data?: {content?: any, aiPrompt?: any, metaData?: any}) {
            if(data?.content) {
                this.content.value = data.content.value;
                if(data.content?.metaData) {
                    this.content.metaData = data.content.metaData;
                }
            }

            if(data?.aiPrompt) {
                this.aiPrompt.value = data?.aiPrompt.value;
            }
        }

}

